
import Vue from 'vue'
import requisitionsToPurchase from '../../../transformers/catalog/warehouse/requisitionsToPurchase'

/**
 * @author jorge nuñez lópez <>
 *
 * Send requisitions to purchase process
 * @param Requisition Requisition object
 * @return {object}
 */

export default (requisition) => {
  const payload = requisitionsToPurchase.send(requisition)
  return Vue.$http.post(`/purchase/create_consolidateds/`, payload)
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/sendRequisitionsToPurchase.js